<template>
  <button
    id="whatsapp-button"
    v-bind="buttonProps"
    @click.stop="onClick"
  >
    <div class="d-flex align-items-center">
      <svg-icon-whatsapp
        :outlined="!hideText"
        :class="!hideText ? 'mr-1 mr-sm-2' : null"
        :size="isDetailView ? 18 : 24"
      />
      <span v-if="!hideText">{{ title }}</span>
    </div>
  </button>
</template>

<script>
  export default {
    components: {
      SvgIconWhatsapp: () =>
        import(/* webpackChunkName: "chunk-svg-icon-whatsapp" */ './svg/icon-whatsapp.vue'),
    },
    props: {
      value: {
        type: String,
        default: '',
      },
      hideText: {
        type: Boolean,
        default: false,
      },
      isDetailView: {
        type: Boolean,
        default: false,
      },
    },

    data() {
      return {
        title: 'Whatsapp',
      }
    },
    computed: {
      buttonClass() {
        return {
          btn: true,
          'btn-block': !this.hideText,
          'btn-whatsapp': !this.hideText,
          'btn-contact-rounded': this.hideText,
        }
      },
      buttonComponent() {
        return 'button'
      },
      buttonProps() {
        return {
          class: this.buttonClass,
          type: 'button',
        }
      },
    },
    methods: {
      onClick() {
        window.open(this.value, '_blank')
        this.$emit('analytics')
      },
    },
  }
</script>
<style>
  @media (max-width: 768px) {
    #whatsapp-button {
      white-space: nowrap;
    }
  }
</style>
